import styled, { css } from 'styled-components'

interface ResponsiveProps {
  isMobile: boolean
}

export const TranscriptionAuthorizerSettingsContainer = styled.div<ResponsiveProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ isMobile }) => isMobile ? 'column' : 'row'};

  margin: 30px 0 15px;
  
  > div {
    max-width: ${({ isMobile }) => isMobile ? '100%' : '470px'};

    p + p {
      padding-top: 20px;
    }
  }
`

export const ToggleContainer = styled.div<ResponsiveProps>`
  ${({ isMobile }) => isMobile && css`
    display: flex;
    justify-content: end;
    margin-top: 15px;
  `}
`

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  p {
    color: #898989;
  }
`